import React from "react";

export default function HelpPage() {
   const containerStyle = {
    backgroundColor: "#ffffff", 
    height: "100vh",
    width: "100vw",
    margin: 0,
    padding: 0,
    overflow: "hidden",
  };

  const iframeStyle = {
    width: "100%",
    height: "100%",
    border: "none",
    backgroundColor: "#ffffff", 
    overflow: "hidden",
  };

   const title = {
   color: "Blue"
  };
  return (
   <div style={containerStyle}>
      <h1 style={title}>Live Chat</h1>
      <iframe
        src="https://live-cp-oc-chat-widget.s3.eu-central-1.amazonaws.com/index.html" 
        style={iframeStyle}
      />
    </div>
  );
}